// extracted by mini-css-extract-plugin
export default {"selectedItemsContainer":"tag-select_selectedItemsContainer__vpNJC"};